import path from 'path';
import {
  ElementTabBarIcon as TabsMenuIcon,
  ElementTabItemIcon as TabsPaneIcon,
  ElementTabsIcon as TabsIcon,
  AddPanelTabs64Icon,
} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import TabsContent from './TabsContent';
import TabsLink from './TabsLink';
import TabsMenu from './TabsMenu';
import TabsPane from './TabsPane';
import TabsWrapper from './TabsWrapper';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {AddTabType} from './dataTypes/AddTabType';
import {DefaultTabType} from './dataTypes/DefaultTabType';
import {TabsWrapperType} from './dataTypes/TabsWrapperType';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EList,
  EEnum,
} from '@packages/systems/wfdl-ast';

const TabsAddPanelIcon = wrapAddPanelIcon(AddPanelTabs64Icon);

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    Tabs: TabsIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelTabs: TabsAddPanelIcon,
    TabsPane: TabsPaneIcon,
    TabsMenu: TabsMenuIcon,
  },

  atoms: {
    TabsContent,
    TabsLink,
    TabsMenu,
    TabsPane,
    TabsWrapper,
  },

  dataTypes: {
    AddTab: AddTabType,
    DefaultTab: DefaultTabType,
    TabsWrapper: TabsWrapperType,
  },

  elementPresets: {
    TabsWrapper: ElementPreset.create({
      factory: EElement({
        id: 'Tabs Wrapper',
        type: qualify(Plugins.name('Tabs'), Component.name('TabsWrapper')),
        data: ERecord({
          tabs: ERecord({
            current: EText('Tab 1'),
            easing: EEnum('ease'),
            fadeIn: ENumber(300),
            fadeOut: ENumber(100),
            type: EText('wrapper'),
          }),
          temp: ERecord({
            tabs: ERecord({
              current: EText(''),
            }),
          }),
          children: EList([
            EElement({
              id: 'Tabs Menu',
              type: qualify(Plugins.name('Tabs'), Component.name('TabsMenu')),
              data: ERecord({
                tag: EEnum('div'),
                tabs: ERecord({
                  type: EText('menu'),
                }),
                children: EList([
                  EElement({
                    id: 'Tabs Link',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsLink')
                    ),
                    data: ERecord({
                      block: EText('inline'),
                      tabs: ERecord({
                        type: EText('link'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 1'),
                      }),
                      children: EList([
                        EElement({
                          id: 'Tabs Wrapper Block',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('Block')
                          ),
                          data: ERecord({
                            tag: EEnum('div'),
                            text: EBoolean(true),
                            children: EList([
                              EElement({
                                id: 'Tabs Wrapper String',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('Tab 1'),
                              }),
                            ]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Tabs Link 2',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsLink')
                    ),
                    data: ERecord({
                      block: EText('inline'),
                      tabs: ERecord({
                        type: EText('link'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 2'),
                      }),
                      children: EList([
                        EElement({
                          id: 'Tabs Wrapper Block 2',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('Block')
                          ),
                          data: ERecord({
                            tag: EEnum('div'),
                            text: EBoolean(true),
                            children: EList([
                              EElement({
                                id: 'Tabs Wrapper String 2',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('Tab 2'),
                              }),
                            ]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Tabs Link 3',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsLink')
                    ),
                    data: ERecord({
                      block: EText('inline'),
                      tabs: ERecord({
                        type: EText('link'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 3'),
                      }),
                      children: EList([
                        EElement({
                          id: 'Tabs Wrapper Block 3',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('Block')
                          ),
                          data: ERecord({
                            tag: EEnum('div'),
                            text: EBoolean(true),
                            children: EList([
                              EElement({
                                id: 'Tabs Wrapper String 3',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('String')
                                ),
                                data: EText('Tab 3'),
                              }),
                            ]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Tabs Content',
              type: qualify(
                Plugins.name('Tabs'),
                Component.name('TabsContent')
              ),
              data: ERecord({
                tag: EEnum('div'),
                tabs: ERecord({
                  type: EText('content'),
                }),
                children: EList([
                  EElement({
                    id: 'Tabs Pane',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsPane')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      tabs: ERecord({
                        type: EText('pane'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 1'),
                      }),
                      children: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Tabs Pane 2',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsPane')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      tabs: ERecord({
                        type: EText('pane'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 2'),
                      }),
                      children: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Tabs Pane 3',
                    type: qualify(
                      Plugins.name('Tabs'),
                      Component.name('TabsPane')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      tabs: ERecord({
                        type: EText('pane'),
                      }),
                      attr: ERecord({
                        'data-w-tab': EText('Tab 3'),
                      }),
                      children: EList([]),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      icon: {
        small: qualify(Plugins.name('Tabs'), iconName('Tabs')),
        medium: qualify(Plugins.name('Tabs'), iconName('AddPanelTabs')),
      },
      label: 'Tabs',
      helpData: {
        description: [
          'Add responsive tabs to group and separate content on your site.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/tabs.986a83e377.mp4',
      },
      category: 'Other',
      addTabIndex: 8,
    }),
  },

  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-tabs.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) => data.tabs && data.tabs.type === 'wrapper',
      },
    },
  ],
});
